import { BundleDto } from '../routes/bundles/store/Bundle';
import ApiHttpClient from './ApiHttpClient';

export default class Bundles {
  constructor(private readonly client: ApiHttpClient) {}

  async getAllBundles(): Promise<BundleDto[]> {
    return this.client.get('v1/provider/bundles');
  }

  async getBundle(bundleId: string): Promise<BundleDto> {
    return this.client.get(`v1/provider/bundles/${bundleId}`);
  }

  async createBundle(bundle: BundleDto): Promise<BundleDto> {
    return this.client.post('v1/provider/bundles', bundle);
  }

  async updateBundle(bundle: BundleDto) {
    return this.client.put(`v1/provider/bundles/${bundle.id}`, bundle);
  }

  async archiveBundle(bundleId: string) {
    return this.client.post(`v1/provider/bundles/${bundleId}/archive`);
  }
}
